
<div class="modal-header border-b">
    <h4 class="modal-title title">{{modelHeader}}</h4> 
    <h4 class="modal-title title" style="margin-left: 30%;">{{environment}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body margin-td">
    <div class="card scrollbar">
        <div class="card-content">
          <div class="card-body">

            <div class="row">
              <div class="col-6">
                <div class="af-form-group">
                  <label translate>{{'lblSyncFrom' | translate}} :</label>
                  <div class="lbl-info">
                    AFX
                  </div>
                </div>  
              </div>
              <div class="col-6">
                <div class="af-form-group">
                  <label>{{ 'lblSyncTo' | translate }} :</label>
                  <div class="lbl-info">
                    <ng-container *ngIf="isMg;else default_label ">
                      {{ getSyncLabel(dmsLogList.moduleId)}}
                    </ng-container>
                    <ng-template #default_label translate>
                      {{ 'lblDMS' | translate }}
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="af-form-group">
                  <label>{{'lblDate' | translate}} :</label>
                  <div class="lbl-info">
                    {{dmsLogList.createDate | date : 'short'}}
                  </div>
                </div>  
              </div>
              <div class="col-6">
                <div class="af-form-group">
                  <label translate>{{'lblStatus' | translate}} :</label>
                  <div class="lbl-info"  [style.color]="dmsLogList.responseStatusCode === 'Success'? 'green': 'red'">
                    {{dmsLogList.responseStatusCode}}
                  </div>
                </div>  
              </div>
              <div class="col-6">
                <div class="af-form-group">
                  <label translate>{{'lblFeatureName' | translate}} :</label>
                  <div class="lbl-info">
                    {{dmsLogList.moduleName}}
                  </div>
                </div>  
                </div>
              <div class="col-6">
                <div class="af-form-group">
                  <label>{{'lblEntityName' | translate}} :</label>
                  <div class="lbl-info">
                    {{dmsLogList.referenceName}}
                  </div>
                </div>  
              </div>
              <div class="col-6">
                <div class="af-form-group">
                  <label translate>{{'lblmethodtype' | translate}} :</label>
                  <div class="lbl-info">
                    {{dmsLogList.methodType}} 
                  </div>
                </div>  
              </div>
              
             
              <div class="col-6">
                <div class="af-form-group">
                  <label translate>{{'lblUrl' | translate}} :</label>
                  <div class="lbl-info">
                    {{dmsLogList.apiUrl}}
                  </div>
                </div>  
              </div>
              <div class="col-6">
                <div class="af-form-group">
                  <label translate>lblRequest: </label>
                  <div class="lbl-info">
                    <textarea class="form-control" readonly  style="height:400px!important">{{dmsLogList.requestJson}}</textarea>
                  </div>
                </div>  
              </div>
              <div class="col-6">
                <div class="af-form-group">
                  <label translate>lblResponse: </label>
                  <div class="lbl-info">
                    <textarea class="form-control" readonly style="height:400px!important">{{dmsLogList.exceptionMessage}}</textarea>
                  
                  </div>
                </div>  
              </div>
            </div>
            
          </div>
        </div>
        
      </div>
  </div>
  <div class="modal-footer" *ngIf="integrationWithDMS">
    
        <a class="btn btn-secondary" ngbTooltip="{{ 'lblSyncToDMS' | translate }}"  tooltipClass="custom-revert"
            (click)="onSyncToDms(dmsLogList.moduleId,dmsLogList.referenceId,dmsLogList.referenceName)" *ngIf="dmsLogList?.syncStatus == 0" translate>
            <span translate >
              lblSyncAgain
            </span>
        </a>
        
    
    <button type="button" class="btn btn-secondary" aria-label="Center Align" (click)="activeModal.dismiss(false)" translate>lblClose</button>
  </div>